'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import ReadMoreText from '@/components/ReadMoreText';

/** Creator description typography, shared by the plain-text and Markdown presentations. */
export const creatorDescriptionTextClassName = 'text-vive-primary-30 landscape:text-vive-primary-30 w-full text-[12px] leading-[18px] tracking-[0.2px] lg:text-[16px] lg:leading-6 lg:tracking-[0.25px] lg:text-white landscape:text-[12px] landscape:leading-[18px] landscape:tracking-[0.2px]';
export const creatorDescriptionReadMoreButtonClassName = 'text-vive-brand-40 text-[12px] lg:text-[14px] landscape:text-[12px] font-semibold';
type CreatorDescriptionReadMoreProps = {
  content: ReactNode;
};

/** Collapsible plain-text creator description. */
function CreatorDescriptionReadMore(t0) {
  const $ = _c(8);
  const {
    content
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("profile-page.about.read-more");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t) {
    t2 = t("profile-page.about.read-less");
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== content || $[5] !== t1 || $[6] !== t2) {
    t3 = <ReadMoreText content={content} collapsible={true} readMoreLabel={t1} readLessLabel={t2} readMoreButtonClassName={creatorDescriptionReadMoreButtonClassName} className={creatorDescriptionTextClassName} />;
    $[4] = content;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
export default CreatorDescriptionReadMore;